import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxCircularGaugeModule, DxChartModule, DxNumberBoxModule, DxTextBoxModule, DxTooltipModule, DxDataGridModule, DxButtonModule } from 'devextreme-angular';
import { ScenarioCardComponent } from './scenario-card.component';
import { RoundIfNumberPipe } from 'src/app/pipes/round-if-number.pipe';
import { NumberToPrecisionPipe } from 'src/app/pipes/number-precision.pipe';

@NgModule({
	declarations: [ScenarioCardComponent, RoundIfNumberPipe, NumberToPrecisionPipe],
	exports: [ScenarioCardComponent],
  imports: [
		CommonModule,
		DxCircularGaugeModule,
		DxChartModule,
		DxNumberBoxModule,
		DxTextBoxModule,
		DxTooltipModule,
		DxDataGridModule,
		DxButtonModule,
  ]
})
export class ScenarioCardModule { }
